import type { PortfolioBookKindV2 } from "@tradvera/contracts";

const BOOKS_SUFFIX = "/books";

export function statementImportCollectionUrlV2(booksEndpoint: string, bookId: string,
  bookKind: PortfolioBookKindV2 = "OWNED_PRIVATE"): string {
  const endpoint = normalizedBooksEndpoint(booksEndpoint);
  const id = requiredId(bookId, "STATEMENT_IMPORT_BOOK_ID_REQUIRED");
  const namespace = bookKind === "PAPER" ? "paper-books" : "owned-books";
  return `${endpoint.slice(0, -BOOKS_SUFFIX.length)}/${namespace}/${encodeURIComponent(id)}/statement-imports`;
}

export function statementImportAdminUnlockUrlV2(booksEndpoint: string): string {
  const endpoint = normalizedBooksEndpoint(booksEndpoint);
  return `${endpoint.slice(0, -"/portfolio-v2/books".length)}/unlock`;
}

export function statementImportCapabilitiesUrlV2(booksEndpoint: string, bookId: string,
  bookKind: PortfolioBookKindV2 = "OWNED_PRIVATE"): string {
  return `${statementImportCollectionUrlV2(booksEndpoint, bookId, bookKind)}/capabilities`;
}

export function statementImportDetailUrlV2(booksEndpoint: string, bookId: string, importId: string,
  bookKind: PortfolioBookKindV2 = "OWNED_PRIVATE"): string {
  return `${statementImportCollectionUrlV2(booksEndpoint, bookId, bookKind)}/${encodeURIComponent(requiredId(importId,
    "STATEMENT_IMPORT_ID_REQUIRED"))}`;
}

export function statementImportActionUrlV2(booksEndpoint: string, bookId: string, importId: string,
  action: "review" | "reconciliation" | "intents" | "confirmations" | "discard-confirmations",
  bookKind: PortfolioBookKindV2 = "OWNED_PRIVATE"): string {
  return `${statementImportDetailUrlV2(booksEndpoint, bookId, importId, bookKind)}/${action}`;
}

export function statementImportEvidenceUrlV2(booksEndpoint: string, bookId: string,
  importId: string, evidenceToken: string, bookKind: PortfolioBookKindV2 = "OWNED_PRIVATE"): string {
  return `${statementImportDetailUrlV2(booksEndpoint, bookId, importId, bookKind)}/evidence/${encodeURIComponent(
    requiredId(evidenceToken, "STATEMENT_IMPORT_EVIDENCE_TOKEN_REQUIRED"))}`;
}

export function statementImportOperationStatusUrlV2(booksEndpoint: string, bookId: string,
  operation: string, idempotencyKey: string, inputFingerprint: string,
  bookKind: PortfolioBookKindV2 = "OWNED_PRIVATE"): string {
  const base = statementImportCollectionUrlV2(booksEndpoint, bookId, bookKind);
  const key = encodeURIComponent(requiredId(idempotencyKey, "STATEMENT_IMPORT_IDEMPOTENCY_KEY_REQUIRED"));
  if (!/^[A-Z_]{3,32}$/u.test(operation)) throw new Error("STATEMENT_IMPORT_OPERATION_REQUIRED");
  if (!/^sha256:v1:[a-f0-9]{64}$/u.test(inputFingerprint)) {
    throw new Error("STATEMENT_IMPORT_INPUT_FINGERPRINT_REQUIRED");
  }
  return `${base}/operations/${operation}/${key}?inputFingerprint=${encodeURIComponent(inputFingerprint)}`;
}

function normalizedBooksEndpoint(value: string): string {
  const endpoint = value.trim().replace(/\/+$/u, "");
  if (!endpoint.endsWith(BOOKS_SUFFIX) || /[?#]/u.test(endpoint)) {
    throw new Error("STATEMENT_IMPORT_BOOKS_ENDPOINT_INVALID");
  }
  return endpoint;
}

function requiredId(value: string, code: string): string {
  const result = value.trim();
  if (!/^[A-Za-z0-9._:/-]{3,160}$/u.test(result)) throw new Error(code);
  return result;
}

